//https://valor-software.com/ngx-bootstrap/#/typeahead
import { Component, OnInit, Input, EventEmitter, Output, TemplateRef, ViewChild } from '@angular/core';
import 'rxjs/add/observable/of';
import { TypeaheadMatch, TypeaheadDirective } from 'ngx-bootstrap';
import { Observable } from 'rxjs/Observable';
import { Params } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import { TypeaheadConfig } from 'app/shared/typeahead/typeahead-config.model';
import { PaginationInfo } from 'app/core/api/api-response.model';

@Component({
    selector: 'app-typeahead-lookup',
    templateUrl: './typeahead-lookup.component.html'
})
export class TypeaheadLookupComponent implements OnInit {
    @Input() disabled: boolean;
    typeaheadLoading: boolean;
    typeaheadNoResults: boolean;
    @Input() fieldName: string;

    searchTermValue: string;
    focused: boolean;

    @Input() 
    dataSource: Observable<any>;

    /*This placeholder replaces the one from the config if provided*/
    @Input()
    placeholder?: string;

    _listSelected: TypeaheadMatch;
    @Input()
    set listSelected(selected: TypeaheadMatch) {
        this._listSelected = selected;
        if (selected) {
            console.log(">> typeaheadDoSelect", selected);
            this.typeaheadDoSelect(selected);
        }
    }

    get listSelected() {
        return this._listSelected;
    }

    /*this supports [(searchTerm)]*/
    @Output()
    searchTermChanged: EventEmitter<string> = new EventEmitter<string>();

    @ViewChild(TypeaheadDirective)
    typeadheadDirective: TypeaheadDirective;

    @Output()
    onSelected = new EventEmitter<TypeaheadMatch>();

    @Output()
    focusChanged = new EventEmitter();

    @Output() onButtonClicked = new EventEmitter<TypeaheadMatch>();

    get searchTerm() {
        return this.searchTermValue;
    }

    set searchTerm(val) {
        console.log('search term chaged', val);
        if (this.searchTermValue != val) {
            this.searchTermValue = val;
            this.searchTermChanged.emit(this.searchTermValue);
        }
    }

    @Input()
    config: TypeaheadConfig;

    @Input()
    itemTemplate: TemplateRef<any>;

    @Input()
    listTemplate: TemplateRef<any>;

    @Input()
    set fetchObservable(fetchObservable: number) {
        ///TODO: Find better way. Hack!
        this.typeadheadDirective.onFocus();
    }

    typeaheadMatchObj: TypeaheadMatch;

    constructor() {
        this.config = new TypeaheadConfig();
    }

    ngOnInit(): void {
        this.typeaheadNoResults = false;
        this.typeaheadLoading = false;
        this.searchTerm = null;
    }

    changeTypeaheadLoading(e: boolean): void {
        this.typeaheadLoading = e;
    }

    changeTypeaheadNoResults(e: boolean): void {
        this.typeaheadNoResults = e;
    }

    typeaheadOnSelect(e: TypeaheadMatch): void {
        this.typeaheadMatchObj = e;
        console.log('Sending Selected value: ', e);
        this.onSelected.emit(e);

        if (this.config.clearAfterOnSelected)
            this.searchTerm = "";
    }

    typeaheadDoSelect(e: TypeaheadMatch) : void {
        console.log("typeaheadDoSelect", e);
        this.typeadheadDirective._container.selectMatch(e);
    }

    typeaheadButtonClicked(): void {
        if (this.typeaheadMatchObj) {
            let obj = this.typeaheadMatchObj; //copy local
            this.typeaheadMatchObj = null; //nulify so not to allow click again
            //console.log('btn clicked', JSON.stringify(obj));
            this.onButtonClicked.emit(obj);
        }
    }

    clearText() {
        this.searchTerm = '';
    }
}




// WEBPACK FOOTER //
// ./src/app/shared/typeahead/typeahead-lookup-component.ts